import { formatTimelineItemLabelForBadge } from './timeline-date-format';

export type AsOfTimelineItem = {
  id: string;
  name: string;
  start_date: string;
  start_precision?: string;
  start_timezone?: string | null;
  end_date?: string | null;
  end_precision?: string | null;
  end_timezone?: string | null;
  source_sequence?: number | null;
  sourceSequence?: number | null;
};

export function compareAsOfTimelineItems(a: AsOfTimelineItem, b: AsOfTimelineItem): number {
  const dateDiff = new Date(a.start_date).getTime() - new Date(b.start_date).getTime();
  if (dateDiff !== 0) return dateDiff;
  const seqA = a.source_sequence ?? a.sourceSequence ?? Number.MAX_SAFE_INTEGER;
  const seqB = b.source_sequence ?? b.sourceSequence ?? Number.MAX_SAFE_INTEGER;
  if (seqA !== seqB) return seqA - seqB;
  return a.name.localeCompare(b.name);
}

export function buildAsOfTimelineSelectOptions(
  items: AsOfTimelineItem[],
  locale?: string
): { value: string; label: string }[] {
  return [...items].sort(compareAsOfTimelineItems).map((item) => ({
    value: item.id,
    label: formatTimelineItemLabelForBadge(
      {
        name: item.name,
        start_date: item.start_date,
        start_precision: item.start_precision || 'day',
        start_timezone: item.start_timezone,
        end_date: item.end_date ?? null,
        end_precision: item.end_precision ?? null,
        end_timezone: item.end_timezone,
      },
      locale
    ),
  }));
}
